import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ytd-hours"
}
const _hoisted_2 = { class: "row justify-center" }
const _hoisted_3 = {
  class: "text-h6",
  "data-test": "hours-kpi"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-weight-thin text-h8 q-mt-sm q-ml-xs" }, "hrs", -1 /* HOISTED */)
const _hoisted_5 = { class: "col text-caption text-weight-light justify-center text-center q-mt-md" }
const _hoisted_6 = {
  key: 1,
  class: "ytd-hours"
}
const _hoisted_7 = { class: "row justify-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-h6",
  "data-test": "hours-kpi"
}
const _hoisted_9 = {
  key: 1,
  class: "text-weight-thin text-h8 q-mt-sm q-ml-xs"
}
const _hoisted_10 = {
  key: 2,
  class: "text-h6",
  "data-test": "hours-kpi"
}
const _hoisted_11 = { class: "col text-caption text-weight-light justify-center text-center q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.heading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(Math.round(_ctx.hours)), 1 /* TEXT */),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("b", null, _toDisplayString(_ctx.convertEnumToStatus(_ctx.status)), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.heading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.heading === 'UTILIZATION')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.hours), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.heading === 'UTILIZATION')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " % "))
              : _createCommentVNode("v-if", true),
            (_ctx.heading !== 'UTILIZATION')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.hours), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("b", null, _toDisplayString(_ctx.heading), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}